import { Box, Button } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { com } from '@eidu/web'
import EntityFieldDisplayGroup from '../shared/EntityFieldDisplayGroup'
import PageLayout from '../shared/PageLayout'
import { KindViewPageProps } from '../KindPages'
import useHasPermission from '../../../permission/useHasPermission'
import EntityAction = com.eidu.sharedlib.entity.permission.EntityAction

const DefaultViewPage = ({ entity, entityType, fields }: KindViewPageProps) => {
  const navigate = useNavigate()
  const navigateToEdit = () => {
    navigate(`/entities/${entityType.id.toString()}/edit/${entity.entity.id.toString()}`)
  }

  const { hasPermission: hasUpdatePermission } = useHasPermission(entity.entity.id, EntityAction.UpdateEntity)

  return (
    <PageLayout
      title={entity.primaryLabelText}
      subtitle={entityType.name}
      auditTargetId={entity.entity.id.toString()}
      actions={hasUpdatePermission ? <Button onClick={navigateToEdit}>Edit</Button> : undefined}
      showBack
    >
      <Box sx={{ flex: 1, minHeight: 0, overflowY: 'auto', pt: 1.5 }}>
        <EntityFieldDisplayGroup entityType={entityType} fields={fields} />
      </Box>
    </PageLayout>
  )
}

export default DefaultViewPage
